<script>
    import {Line} from 'vue-chartjs'

    export default {
        extends: Line,

        props: {
            chartData: {
                type: Object,
                default: null
            },
            options: {
                type: Object,
                default: null
            }
        },

        computed: {
            data: function() {
                    return this.chartData;
                }
            },


        mounted () {
            this.renderChart(this.chartData, this.options)
        },

        watch: {
            chartData: function (){
                this.$data._chart.destroy()
                this.renderChart(this.chartData, this.options)
            }
        }

    }
</script>